import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { ThemeProvider } from 'styled-components';

import Table from 'ravenjs/lib/Table';
import Typography from 'ravenjs/lib/Typography';
import { getMergedThemeFromSchema } from 'ravenjs/utils/theme';
import { warning } from 'ravenjs/utils/warning';

import DataListBody from './DataListBody';
import DataListHead from './DataListHead';
import DataListStyled from './DataListStyled';

function DataList(props) {
    const { actions, data, schema, style } = props;
    const label = _get(schema, 'label');
    // Don't render the DataList if a schema is not provided.
    if (_isEmpty(schema)) {
        warning(!_isEmpty(schema), [
            `A <DataList /> requires a 'schema' prop to build the Data List Table.`,
        ]);
        return null;
    }
    // Extract info out of the schema.
    const { table: tableProps = {} } = schema;
    const tableCols = _get(schema, 'columns', []);
    const hideHead = _get(schema, 'hideHead', false);
    const sortDataByKey = _get(schema, 'rows.sortDataByKey', '');

    if (!_isEmpty(data) && sortDataByKey) {
        data.sort((a, b) => {
            if (a[sortDataByKey] < b[sortDataByKey]) {
                return -1;
            }
            if (a[sortDataByKey] > b[sortDataByKey]) {
                return 1;
            }
            return 0;
        });
    }

    // Render the `DataList`.
    return (
        <ThemeProvider theme={getMergedThemeFromSchema(props)}>
            {label && (
                <Typography gutterBottom="20px" type="label" fontWeight="700">
                    {label}
                </Typography>
            )}
            <DataListStyled style={style}>
                <Table
                    cols={tableCols.length || null}
                    style={{ position: 'relative' }}
                    {...tableProps}
                >
                    {!hideHead && <DataListHead actions={actions} data={data} schema={schema} />}
                    <DataListBody actions={actions} data={data} schema={schema} />
                </Table>
            </DataListStyled>
        </ThemeProvider>
    );
}

DataList.propTypes = {
    actions: PropTypes.object,
    data: PropTypes.array,
    schema: PropTypes.object,
    style: PropTypes.object,
};

DataList.defaultProps = {
    actions: null,
    data: null,
    schema: null,
    style: null,
};

export default DataList;
